/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Context_DescInputs */

const en_mk_context_desc = /** @type {(inputs: Mk_Context_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every correction you type in chat automatically becomes a new rule for agents. Your team never repeats the same instruction, and anything an agent has learned always shows up as something you can edit or delete at any time.`)
};

const id_mk_context_desc = /** @type {(inputs: Mk_Context_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap koreksi yang kamu ketik di chat otomatis jadi aturan baru bagi agen. Timmu tidak perlu mengulang instruksi yang sama, dan apa pun yang sudah dipelajari agen selalu tampil sebagai info yang bisa diedit atau dihapus kapan saja.`)
};

/**
* | output |
* | --- |
* | "Every correction you type in chat automatically becomes a new rule for agents. Your team never repeats the same instruction, and anything an agent has learne..." |
*
* @param {Mk_Context_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_context_desc = /** @type {((inputs?: Mk_Context_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Context_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_context_desc(inputs)
	return en_mk_context_desc(inputs)
});